// extracted by mini-css-extract-plugin
module.exports = {"nav-bar":"NavBar_nav-bar__2daSH","logo":"NavBar_logo__r8not","profile-icon":"NavBar_profile-icon__1tBK0","nav-button":"NavBar_nav-button__2P95t"};